import { Button } from "@workspace/web-ui/components/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@workspace/web-ui/components/dialog";
import { X } from "lucide-react";
import { useLogoutModal } from "../store/logout-store";

interface LogoutProps {
    logout: () => void;
}

export function LogoutConfirmModal({logout}: LogoutProps) {
  const { isOpen, close } = useLogoutModal()

  const handleConfirm = () => {
    // your logout logic here
    logout()
    close()
    console.log("Logging out...")
  }

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-w-sm rounded-xl p-6 text-center [&>button]:hidden ">
        <div className="flex justify-between items-start w-full">
          <div />
          <button onClick={close} className="absolute right-4 top-4 size-8 rounded-full flex justify-center items-center bg-[#0404040D] text-center text-gray-400 hover:bg-[#0404040D] hover:text-gray-600 !mt-0">
            <X className="h-5 w-5 text-gray-500 m-0" />
          </button>
        </div>

        <DialogHeader>
          <DialogTitle className=" text-center text-4xl font-semibold mb-2">Log Out</DialogTitle>
          <DialogDescription className="text-[#202020CC] text-center text-base mt-2">
            Are you sure you want to log out? You can always log back in.
          </DialogDescription>
        </DialogHeader>

        <div className="flex justify-center gap-4 mt-6 w-full">
          <Button variant="outline" onClick={close} className="w-full rounded-lg px-3 py-5">Cancel</Button>
          <Button onClick={handleConfirm} className="w-full bg-blue-600 text-white rounded-lg px-3 py-5 hover:bg-blue-700">Confirm</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
